(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-validate/assets/javascript/components/instructions-info.js') >= 0) return;  svs.modules.push('/modules/tickets-validate/assets/javascript/components/instructions-info.js');
"use strict";

const {
  WidgetArea
} = svs.components.tb_ui_react.widget_area;
const {
  GridCol,
  GridRow
} = svs.ui.ReactGrid;
const {
  NeedHelp
} = svs.tur;
setGlobal('svs.ticketsValidate.components.InstructionsInfo', _ref => {
  let {
    showStepByStep = true
  } = _ref;
  return React.createElement(GridRow, {
    className: "f-content u-flex u-flex-justify-content-center padding-h-1 align-center"
  }, React.createElement(GridCol, {
    am: 8,
    lg: 8,
    sm: 12
  }, showStepByStep && React.createElement(WidgetArea, {
    areaName: "stepByStepWidget",
    className: "pre-wrap"
  }), React.createElement(NeedHelp, null)));
});

 })(window);